const secondaryNav = (function() {
  const $secondaryNav = $('.secondary-nav');

  // Secondary nav mobile toggle
  const mobileMenuToggle = function() {
    $('.secondary-nav-toggle').on('click', function(e) {
      e.preventDefault();
      $('.secondary-nav').toggleClass('active');
    });
  };


  const mainContentHeight = function() {
    $(window).on('load', function() {
      const sidebarHeight = $('.secondary-sidebar').outerHeight();
      const contentHeight = $('.page-content').outerHeight();

      if (sidebarHeight >= contentHeight) {
        $('.page-content').css('height', sidebarHeight);
      } else {
        $('.page-content').css('height', 'auto');
      }
    });
  };


  const windowResize = function() {
    $(window).resize(function() {
      mainContentHeight();
    });
  };

  const init = function() {
    if ($secondaryNav.length) {
      mobileMenuToggle();
      mainContentHeight();
      windowResize();
    }
  };

  return {
    init,
  };
})();

secondaryNav.init();



// WEBPACK FOOTER //
// ./library/js/modules/secondary-nav.js